let FilterService = {};

FilterService.filterBlockList = (filters, blocks, useNameAsValue = true) => {
    let filteredBlocks = blocks.filter(function (block) {
        if (!(block.fromSoftwareName !== null ? filters.fromSoftwareNameFilter === '' ? true : block.fromSoftwareName === filters.fromSoftwareNameFilter : filters.fromSoftwareNameFilter === '')) {
            return false;
        }
        if (!(block.fromSoftwareVersion !== null ? filters.fromSoftwareVersionFilter === '' ? true : block.fromSoftwareVersion === filters.fromSoftwareVersionFilter : filters.fromSoftwareVersionFilter === '')) {
            return false;
        }
        if (!(block.toSoftwareName !== null ? filters.toSoftwareNameFilter === '' ? true : block.toSoftwareName === filters.toSoftwareNameFilter : filters.toSoftwareNameFilter === '')) {
            return false;
        }
        if (!(block.toSoftwareVersion !== null ? filters.toSoftwareVersionFilter === '' ? true : block.toSoftwareVersion === filters.toSoftwareVersionFilter : filters.toSoftwareVersionFilter === '')) {
            return false;
        }
        if (block.groups !== null) {
            if (filters.groupFilter !== '') {
                let whatToReturn = false;
                block.groups.every((group) => {
                    if (group === filters.groupFilter) {
                        whatToReturn = true;
                        return false;
                    }
                    return true;
                });
                return whatToReturn;
            }
        } else {
            if (filters.groupFilter !== '') {
                return false;
            }
        }
        return true;
    });
    if (useNameAsValue) {
        return filteredBlocks.map(function (block) {
            return {
                value: block.className,
                text: block.className + (block.className !== "" ? " ( " + (block.fromSoftwareName != null ? "from: " + block.fromSoftwareName + (block.fromSoftwareVersion != null ? " (" + block.fromSoftwareVersion + ")" : "") : "") + (block.toSoftwareName != null ? (block.fromSoftwareName != null ? ", " : "") + "to: " + block.toSoftwareName + (block.toSoftwareVersion != null ? " (" + block.toSoftwareVersion + ")" : "") : "") + (block.groups != null ? (block.fromSoftwareName != null || block.toSoftwareName != null ? ", " : "") + "groups: " + block.groups : " ") + " )" : ""),
                block: block
            }
        });
    } else {
        filteredBlocks.unshift({className: '', blockType: "BackendBlock"});
        return filteredBlocks.map(function (block) {
            return {
                value: block,
                text: block.className + (block.className !== "" ? " ( " + (block.fromSoftwareName != null ? "from: " + block.fromSoftwareName + (block.fromSoftwareVersion != null ? " (" + block.fromSoftwareVersion + ")" : "") : "") + (block.toSoftwareName != null ? (block.fromSoftwareName != null ? ", " : "") + "to: " + block.toSoftwareName + (block.toSoftwareVersion != null ? " (" + block.toSoftwareVersion + ")" : "") : "") + (block.groups != null ? (block.fromSoftwareName != null || block.toSoftwareName != null ? ", " : "") + "groups: " + block.groups : " ") + " )" : "")
            }
        });
    }
};

FilterService.getFilterLists = (blocks) => {
    let fromSoftwareNames = [];
    let toSoftwareNames = [];
    let fromSoftwareVersions = [];
    let toSoftwareVersions = [];
    let groups = [];

    blocks.forEach(block => {
        if (block.fromSoftwareName !== null && block.fromSoftwareName !== undefined && block.fromSoftwareName !== "" && !fromSoftwareNames.includes(block.fromSoftwareName)) {
            fromSoftwareNames.push(block.fromSoftwareName);
        }
        if (block.fromSoftwareVersion !== null && block.fromSoftwareVersion !== undefined) {
            let added = false;
            fromSoftwareVersions.forEach(fromSoftwareVersion => {
                if (fromSoftwareVersion.software === block.fromSoftwareName) {
                    if (!(fromSoftwareVersion.versions.includes(block.fromSoftwareVersion))) {
                        fromSoftwareVersion.versions.push(block.fromSoftwareVersion);
                    }
                    added = true;
                }
            });
            if (!added) {
                fromSoftwareVersions.push({
                    software: block.fromSoftwareName,
                    versions: [block.fromSoftwareVersion]
                });
            }
        }

        if (block.toSoftwareName !== null && block.toSoftwareName !== undefined && block.toSoftwareName !== "" && !toSoftwareNames.includes(block.toSoftwareName)) {
            toSoftwareNames.push(block.toSoftwareName);
        }
        if (block.toSoftwareVersion !== null && block.toSoftwareVersion !== undefined) {
            let added = false;
            toSoftwareVersions.forEach(toSoftwareVersion => {
                if (toSoftwareVersion.software === block.toSoftwareName) {
                    if (!(toSoftwareVersion.versions.includes(block.toSoftwareVersion))) {
                        toSoftwareVersion.versions.push(block.toSoftwareVersion);
                    }
                    added = true;
                }
            });
            if (!added) {
                toSoftwareVersions.push({
                    software: block.toSoftwareName,
                    versions: [block.toSoftwareVersion]
                });
            }
        }

        if (block.groups !== null && block.groups !== undefined) {
            block.groups.forEach(group => {
                if (!groups.includes(group)) {
                    groups.push(group);
                }
            });
        }
    });

    let filterSelectorsOptions = {
        fromSoftwareNameFilterOptions: [],
        fromSoftwareVersions: [],
        toSoftwareNameFilterOptions: [],
        toSoftwareVersions: [],
        groupFilterOptions: []
    };
    filterSelectorsOptions.fromSoftwareNameFilterOptions = fromSoftwareNames.map(function (key) {
        return {value: key, text: key}
    });
    filterSelectorsOptions.fromSoftwareNameFilterOptions.unshift(
        {value: '', text: "--no filter--"}
    );

    filterSelectorsOptions.fromSoftwareVersions = fromSoftwareVersions;

    filterSelectorsOptions.toSoftwareNameFilterOptions = toSoftwareNames.map(function (key) {
        return {value: key, text: key}
    });
    filterSelectorsOptions.toSoftwareNameFilterOptions.unshift(
        {value: '', text: "--no filter--"}
    );

    filterSelectorsOptions.toSoftwareVersions = toSoftwareVersions;

    filterSelectorsOptions.groupFilterOptions = groups.map(function (key) {
        return {value: key, text: key}
    });
    filterSelectorsOptions.groupFilterOptions.unshift(
        {value: '', text: "--no filter--"}
    );
    return filterSelectorsOptions;
};

FilterService.softwareVersionFilterOptions = (softwareVersionsByName, nameFilter) => {
    let selectedSoftwareVersions = [];
    softwareVersionsByName.forEach(SoftwareVersion => {
        if (SoftwareVersion.software === nameFilter) {
            selectedSoftwareVersions = SoftwareVersion.versions;
        }
    });
    let softwareVersionFilterOptions = selectedSoftwareVersions.map(function (key) {
        return {value: key, text: key}
    });
    softwareVersionFilterOptions.unshift(
        {value: '', text: "--no filter--"}
    );
    return softwareVersionFilterOptions;
};

export default FilterService;
